import { useTheme } from '@mui/material';
import RequireAuth from '../../requireAuth';
import DashboardHeader from '../../dashboardHeader';
import { propertiesPath } from '../../../../constants';
import MessageTable from './messagesTable';

const UrgentMessagesDashbaord = () => {
    const theme = useTheme();

    const mainStyle = {
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.brand.linen,
        paddingTop: 'var(--nav-height)',
        minHeight: '100vh',
        boxSizing: 'border-box',
    };

    return (
        <div style={mainStyle}>
            <RequireAuth />

            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px 20px 40px' }}>
                <DashboardHeader
                    eyebrow="Manage"
                    heading="Urgent Messages"
                    showBackLink
                    backTo={propertiesPath}
                    backLabel="Properties"
                />

                <MessageTable />
            </div>
        </div>
    );
};

export default UrgentMessagesDashbaord;
